export enum PAYMENT_TYPES {
  IMMEDIATE = 'Immediate',
  SCHEDULED = 'Scheduled',
  AUTOPAY = 'Autopay',
}

export enum PAYMENT_STATUS_BG_COLOR {
  GRAY = 'gray-2',
  YELLOW = 'yellow-1',
  GREEN = 'green-1',
  RED = 'red-1',
  BLUE = 'blue-primary',
  GREEN_4 = 'green-4',
  RED_4 = 'red-4',
  TEXT_DARK = 'text-dark',
  GRAY_4 = 'gray-4',
}

export enum PAYMENT_STATUS_ICONS {
  CHECK = 'check',
  CLOSE = 'close',
  WARNING = 'warning',
  REPLY = 'reply-line',
  SUCCESS = 'circle-check-line',
  DANGER = 'danger',
  DELETE = 'trash',
  ALERT = 'alert',
}

export enum PAYMENT_STATUS {
  SCHEDULED = 'Scheduled',
  ACCOUNT_CHARGED = 'Account Charged',
  APPLIED_TO_BILL = 'Applied To Bill',
  CANCELLED = 'Cancelled',
  DECLINED = 'Declined',
  RETURNED = 'Returned',
  PROCESSED = 'Processed',
  PAYMENT = 'Payment',
  //Below status added for Government users
  PAID = 'Paid',
  REFUND_VOIDED = 'Refund Voided',
  REFUND = 'Refund',
  REVERSED = 'Reversed',
  REMOVED = 'Removed',
}

export const PAYMENT_STATUS_TEXT = {
  SCHEDULED: 'Scheduled on',
  ACCOUNT_CHARGED: 'Account Charged on',
  APPLIED_TO_BILL: 'Applied to Bill on',
  CANCELLED: 'Cancelled on',
  DECLINED: 'Declined on',
  RETURNED: 'Returned on',
};

export const EZBLUE_PAYMENT = 'E-Z BLUE PAYMENT';
export const ACH = 'ACH';
